import { useEffect, useState } from "react";
import ChatWidget from "./Components/ChatWidget/ChatWidget";
import "./global.css";

function App(){
  const VERSION = "1.0.16";
  useEffect(() => {
    console.log(VERSION);
  }, []);

  return (
    <>
      <ChatWidget version={VERSION}/>
    </>
  );
}

export default App;